import {
  CommonEntitiesListResponse,
  SupportedLanguageResponse,
} from '@docbay/schemas';
import axiosInstance from 'integration/api/axiosInstance';

/**
 * API methods for accessing language-related data.
 */
export const LanguagesAPI = {
  /**
   * Retrieves a list of supported languages.
   *
   * @returns A promise that resolves to the response object containing the list of supported languages.
   */
  getSupportedLanguages: async () => {
    return await axiosInstance.get<
      CommonEntitiesListResponse<SupportedLanguageResponse>
    >('/languages/supported');
  },
};
